enum WorkReportType {
    TEAM_ALIGNMENT = 'team_alignment',
    CLIENT_ALIGNMENT = 'client_alignment',
    QA = 'qa',
    DESIGN = 'design',
    REVISION = 'revision',
    TIME_OFF = 'time_off',
}

export default WorkReportType;
